import { Alert, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function SimpleAlert({
  severity,
  message,
  mb,
  show = true,
  paper = false,
  width = "100%",
  testId
}) {
  const { t } = useTranslation();
  if (!show) {
    return null;
  }
  if (paper) {
    return (
      <Paper sx={{ p: 2 }} data-testid={testId}>
        <Alert severity={severity} sx={{ mb: mb }}>
          <Typography>{t(message)}</Typography>
        </Alert>
      </Paper>
    );
  }
  return (
    <Alert severity={severity} sx={{ mb: mb, width: width }} data-testid={testId}>
      <Typography>{t(message)}</Typography>
    </Alert>
  );
}
